const Images = {
  Raise: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/Group%2048099673.png',
  Education: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/education.png',
  Medal: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/medal-star.png',
  Credit: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/two_credit_cart.png',
  DefaultProfileImage: 'https://alumnikenverse.blob.core.windows.net/images/avatar.png',
  DefaultOrganizationLogo: 'https://alumnikenverse.blob.core.windows.net/images/defaultOrgImage.webp',
  AuthLayoutBg: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/LoginBackground.png',
  NoDataTheme: 'https://alumnikenverse.blob.core.windows.net/images/no-event-investors.png',
  PostJobBanner: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/PostJob.png',
  EventCardCoverImage: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/noimage.jpg',
  OnBoardBg: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/backgroundonboard.png',
  Complain: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/Objects.png',
  BeginSurvey: 'https://alumnikenverse.blob.core.windows.net/images/survey.png',
  CreateSurvey: 'https://alumnikenverse.blob.core.windows.net/images/create-survey.png',
  SurveyThankYou: 'https://alumnikenverse.blob.core.windows.net/images/survey-thankyou.png',
  entreprenursOfKen42: 'https://alumnikenverse.blob.core.windows.net/images/pioneers of ken42.png',
  investorLoginVector: 'https://alumnikenverse.blob.core.windows.net/images/Vector.png',
  turbostartInvestor: 'https://alumnikenverse.blob.core.windows.net/images/turbostart-investor.png',
  turbostartWhiteLogo: 'https://alumnikenverse.blob.core.windows.net/images/turbostart_logo_white.png',
  turbostartLogo: 'https://alumnikenverse.blob.core.windows.net/images/turbostart_logo.png',
  defaultImage: 'https://alumnikenverse.blob.core.windows.net/images/default-image.jpg',
  kennovateLogo: 'https://alumnikenverse.blob.core.windows.net/images/investor-logo.png',
  kennovateLogo2: 'https://alumnikenverse.blob.core.windows.net/images/Kennovate logo.png',
  portfolioDummy: 'https://alumnikenverse.blob.core.windows.net/images/portfolio.png',
};
const Svg = {
  instructionVector: 'https://alumnikenverse.blob.core.windows.net/images/instructionsVector.svg',
  kennovateHeader: 'https://alumnikenverse.blob.core.windows.net/images/KennovateHeader.svg',
  dueTranche: 'https://alumnikenverse.blob.core.windows.net/images/due.svg',
  nextTranche: 'https://alumnikenverse.blob.core.windows.net/images/nextTranche.svg',
  notificationEmpty: 'https://alumnikenverse.blob.core.windows.net/images/Notification.svg',
  portfolioDetail: 'https://alumnikenverse.blob.core.windows.net/images/portfolioDetail.svg',
  investorComplaint: 'https://alumnikenverse.blob.core.windows.net/images/investor-complaint.svg',
  investorRocket: 'https://alumnikenverse.blob.core.windows.net/images/Rocket.svg',
  PostEventBanner: 'https://alumnikenverse.blob.core.windows.net/images/investor-plant.svg',
  emptyPlaceholderPitch: 'https://alumnikenverse.blob.core.windows.net/images/emptyPlaceholderPitch.svg',
  coeImapctEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/coeImapctEmptyPlaceholder.svg',
  founderEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/founderEmptyPlaceholder.svg',
  revenueEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/revenueEmptyPlaceholder.svg',
  pitchEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/pitchEmptyPlaceholder.svg',
  ProductEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/ProductEmptyPlaceholder.svg',
  tsInsightEmptyPlaceholder: 'https://alumnikenverse.blob.core.windows.net/images/tsInsightEmptyPlaceholder.svg',
};
const Icons = {
  Error: 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/error.png',
  DefaultServiceIcon: 'https://inazstgpfs3001.blob.core.windows.net/assets/Ken42%20Alumni/PNG/education.png',
  Location: 'https://alumnikenverse.blob.core.windows.net/images/Group.png',
  Designation: 'https://alumnikenverse.blob.core.windows.net/images/designation.png',
  Like: 'https://alumnikenverse.blob.core.windows.net/images/like.png',
  Share: 'https://alumnikenverse.blob.core.windows.net/images/share.png',
  Comment: 'https://alumnikenverse.blob.core.windows.net/images/comment.png',
  ArrowForward: 'https://alumnikenverse.blob.core.windows.net/images/arrowForward.png',
  Check: 'https://alumnikenverse.blob.core.windows.net/images/Check.png',
  Profile: 'https://alumnikenverse.blob.core.windows.net/images/profile.png',
  editFileIcon: 'https://alumnikenverse.blob.core.windows.net/images/editFileIcon.png',
  leafIcon: 'https://alumnikenverse.blob.core.windows.net/images/leafIcon.png',
  websplitIcon: 'https://alumnikenverse.blob.core.windows.net/images/websplitIcon.png',
  linkedinIcon: 'https://alumnikenverse.blob.core.windows.net/images/linkedin-icon.png',
  userClientIcon: 'https://alumnikenverse.blob.core.windows.net/images/users.png',
  awardIcon: 'https://alumnikenverse.blob.core.windows.net/images/medal-star.svg',
  linkedinIconBlue: 'https://alumnikenverse.blob.core.windows.net/images/linkedin-icon-blue.png',
  globe: 'https://alumnikenverse.blob.core.windows.net/images/ph_globe.png',
  india: 'https://alumnikenverse.blob.core.windows.net/images/indiaflag.png',
  rocket: 'https://alumnikenverse.blob.core.windows.net/images/general.png',
  graph: 'https://alumnikenverse.blob.core.windows.net/images/business.png',
  quoteIcon: 'https://alumnikenverse.blob.core.windows.net/images/quoteIcon.png',
  copyIcon: 'https://alumnikenverse.blob.core.windows.net/images/copy-icon.svg',
};

const Flags = {
  unitedStates: 'https://alumnikenverse.blob.core.windows.net/images/united states.webp',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { Images, Icons, Svg, Flags };
